import React from "react";
import ReactGA from "react-ga";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import {caseData} from "./data";
// import titleImg from "../../images/homepage/title.png";
import titleImg2 from "../../images/homepage/title.png";
import { css } from "@emotion/css";

const Container = styled.div`
  width: 90%;
  max-width: 1180px;
  margin: auto;
`;

const Title = styled.h1`
  color: #30251D;
  margin-bottom: 30px;
  img {
    display: block;
    margin: auto;
    width: 90%;
    max-width: 540px;
    @media screen and (max-width: 767px) {
      width: 80%;
    }
  }
  span {
    display: block;
    font-weight: 900;
    font-size: 100px;
    line-height: 148px;
    text-align: center;
    letter-spacing: 0.4em;
    @media screen and (max-width: 1000px) {
      font-size: 70px;
      line-height: 100px;
    }
    @media screen and (max-width: 767px) {
      font-size: 38px;
      line-height: 72px;
      margin-top: 10px;
    }
  }
  
`;

const Note = styled.p`
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0.1rem;
  color: #30251D;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
`;

const Line = styled.div`
  width: 40px;
  height: 2px;
  background-color: #30251D;
  margin: 60px auto;
  @media screen and (max-width: 767px) {
    margin: 40px auto;
  }
`;

const LinkBox = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: 800px) {
    justify-content: center;
  }
`;

const LinkItem = css`
  width: 30%;
  max-width: 360px;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin-bottom: 80px;
  }
`;
const LinkIntro = styled.div`
  position: relative;
  width: 100%;
  background-position: center;
  background-image: url(${props => props.bg});
  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;
const LinkCase = styled.div`
  width: 100%;
  max-width: 145px;
  padding: 15px;
  height: 130px;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &::before {
    content: '';
    background-color: rgba(48, 37, 29, 0.8);
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const CaseName = styled.p`
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 0.1rem;
  color: #FFFFFF;
  position: relative;
  z-index: 1;
  white-space: break-spaces;
`;


const CaseText = styled.p`
  font-weight: 900;
  font-size: 26px;
  line-height: 44px;
  color: rgba(255, 255, 255, 0.3);
  position: relative;
  z-index: 1;
`;

const P = styled.p`
  font-size: 18px;
  letter-spacing: 0.1rem;
  color: #30251D;
  margin-top: 20px;
  height: 85px;
  @media screen and (max-width: 767px) {
    height: auto;
    font-size: 16px;
  }
`;

const More = styled.div`
  position: relative;
  width: 45%;
  margin-left: auto;
  padding: 2px 4px;
  margin-top: 50px;
  border: 1px solid #30251D;
  font-size: 16px;
  text-align: right;
  letter-spacing: 0.1rem;
  color: #30251D;
  &::before {
    content: '';
    width: 40px;
    height: 1px;
    display: block;
    background-color: #30251D;
    position: absolute;
    top: 50%;
    left: -30px;
  }
`;

const HomeCase = () => {
  return (
    <Container>
      <Title>
        <p>
          <img src={titleImg2} alt=""/>
          <span>最重要的乘客</span>
        </p>
      </Title>
      <Note>三段冒險、三則故事、三個最重要的乘客</Note>
      <Line />
      <LinkBox>
        {/* <LinkItem>
          <LinkIntro>
            <LinkCase>
              <CaseName>赤翡翠</CaseName>
              <CaseText>CASE 01</CaseText>
            </LinkCase>
          </LinkIntro>
        </LinkItem> */}

        {caseData.map((items, keys) => {
          const {bg, caseText, bird, text, link} = items;
          return (
            <Link to={link} key={keys} className={LinkItem} onClick={()=>{
              ReactGA.event({
                category: "202012_PRADO",
                action: "Click",
                label: `HomePageCase-${bird}`,
              });
            }}>
              {/* <LinkItem > */}
                <LinkIntro bg={bg}>
                  <LinkCase>
                    <CaseName>{bird}</CaseName>
                    <CaseText>{caseText}</CaseText>
                  </LinkCase>
                </LinkIntro>
                <P>{text}</P>
                <More>
                  MORE
                </More>
              {/* </LinkItem> */}
            </Link>
          )
        })}




      </LinkBox>
    </Container>
  )
};

export default HomeCase;